import React from 'react';

function SubdivisionAccordion(props) {
    const subdivisions = props.subdivisions;
    return (
        <details className="small-chat-subdivision-warning-container">
            <summary className="small-chat-subdivision-summary">
                <span className="body-regular colour-primary">
                    ⚠️ {subdivisions.length} subdivision warning{subdivisions.length > 1 ? "s" : ""}
                </span>
            </summary>
            <div className="small-chat-subdivision-details">
                {subdivisions.map((subdivision, ii) => (
                    <div key={ii} className="small-chat-subdivision-item">
                        <div className="small-chat-subdivision-name">
                            <span className="body-semibold colour-primary">
                                {subdivision.subdivision}{" "}
                            </span>
                            <span className="body-regular colour-secondary">
                                ({subdivision.verdict})
                            </span>
                        </div>
                            <div className="small-chat-subdivision-analysis">
                                <span className="body-regular colour-primary">
                                    {subdivision.analysis}
                                </span>
                            </div>
                    </div>
                ))}
            </div>
        </details>
    )
};

export default SubdivisionAccordion;